<template>
	<div class="header">
		<div class="head1 fc-bet">
			<div class="logo fc">
				<img src="../../assets/logo.png" >
				<div class="txt">
					<h1>某某医院挂号缴费管理系统</h1>
					<p>XX HOSPITAL REGISTRATION AND PAYMENT MANAGEMENT SYSTEM</p>
				</div>
			</div>
			<div class="time">
				<strong v-text="timeTxt"></strong>
				<p v-text="dateTxt"></p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'q-name',
		props: {
			msg: String
		},
		data() {
			return {
				timer:null,
				timeTxt:null,
				dateTxt:null
			}
		},
	
		
		mounted() {
				  var that=this;
			that.riqi()
					that.timer = setInterval(function() {
						that.riqi()
					}, 1000)
		},
		methods: {
			riqi() {
						var myDate = new Date();
						var year = myDate.getFullYear();
						var month = myDate.getMonth() + 1;
						var date = myDate.getDate();
						var hours = myDate.getHours();
						var minutes = myDate.getMinutes();
						var seconds = myDate.getSeconds();
						var weekend = myDate.getDay();
			
						if (month < 10) {
							month = '0' + month
						}
						if (date < 10) {
							date = '0' + date
						}
						if (hours < 10) {
							hours = '0' + hours
						}
						if (minutes < 10) {
							minutes = '0' + minutes
						}
						if (seconds < 10) {
							seconds = '0' + seconds
						}
						this.dateTxt = year + "-" + month + "-" + date 
						this.timeTxt= hours + ":" + minutes
						
					},
		},
		beforeDestroy() {
			clearTimeout(this.timer);
		}
		
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less">
	.head1{
		height: 210px;
		color: #fff;
		padding-left: 50px;
		padding-right: 60px;
		img{
			display: block;
			margin-right: 21px;
			height: 100px;
		}
		.txt{
			h1{
				font-size: 44px;
				line-height: 1.1em;
			}
			p{
				font-size: 16px;
				line-height: 1.1em;
			}
		}
		.time{
			text-align: center;
			
				font-family: AvantiBold;
			strong{
				font-size: 54px;
				font-weight: 400;
				
			}
			p{
				font-size: 25px;
			}
		}
	}
</style>
